import cookieFactory from './index';

export default class utmCookie {
  constructor() {
    this.params = new URLSearchParams(window.location.search);
    this.cookie = cookieFactory('utm_params');
  }

  get() {
    let utmParams = null;

    if (this.params.get('utm_campaign')) {
      utmParams = {
        utm_campaign: this.params.get('utm_campaign'),
        utm_source: this.params.get('utm_source'),
      };
      this.set();
    } else if (this.cookie.get()) {
      utmParams = JSON.parse(this.cookie.get());
    }

    return utmParams;
  }

  set() {
    if (this.params.get('utm_campaign')) {
      this.cookie.set({
        utm_campaign: this.params.get('utm_campaign'),
        utm_source: this.params.get('utm_source'),
      });
    };
  }

  remove() {
    if (this.cookie.get()) {
      this.cookie.remove();
    }
  }
};
